<template>
<kayit title="Satıcı Tanıtımı" v-on:kayitgetir="kayitgetir" v-on:edititem="edititem" v-on:insertitem="insertitem" v-on:deleteitem="deleteitem" :tableheaders="headers" :tableitems="items" :item="item" :status="status">
  <template >

    <!-- <td>{{ props.item["SirketNo"]}}</td>
     <td>{{ props.item["SirketIsmi"]}}</td>  -->

  </template>

  <template slot="toolbarbottom">
    <br>

    <v-layout row="" wrap="">
      <div class="flex sm5">
        <v-select hide-details :items="saticiTipleri" label="Satici Tipi Seçiniz" item-text="text" item-value="id" outline v-model="saticiTipi">
        </v-select>
      </div>
    </v-layout>

  </template>

  <template slot="dialogmain" slot-scope="prop">
    <saticibilgi v-model="prop.item"></saticibilgi>
  </template>

</kayit>
</template>

<script>
import kayit from "@/components/app/coper/comp/kayit.vue";
import tool from "../../tools";
import rez from "../../rezervasyon";
import saticibilgi from "@/components/app/coper/comp/saticibilgi.vue";

export default {
  components: {
    kayit,
    saticibilgi
  },
  data() {
    return {
      status: tool.NewSatatus(),
      saticiTipi: "Otel",
      saticiTipleri: rez.saticiTipleriStr,

      headers: [{
          text: "SirketNo",
          value: "SirketNo"
        },
        {
          text: "Kod",
          value: "Kod"
        },
        {
          text: "İşlem",
          value: "islemsutunu",
          sortable: false
        }

      ],

      items: [],
      item: {

      },
      cariSirketList: [],

    };
  },
  methods: {
    kayitgetir: kayitgetir,
    kayitupdate: kayitupdate,
    kayitInsert: kayitInsert,
    edititem: edititem,
    insertitem: insertitem,
    deleteitem: deleteitem,

  },

};

function edititem(val) {
  var i = this.items.findIndex(k => k.Ref == val.Ref);
  Object.assign(this.items[i], val);
  this.kayitupdate(val);
}

function insertitem(val) {
  this.kayitInsert(val);
}

function deleteitem(val) {

  val.Deleted = "E";
  val.DeletedDate = tool.Now_yyyy_MM_dd();
  this.kayitupdate(val);
  const index = this.items.indexOf(val);
  this.items.splice(index, 1);

}

function kayitgetir(val) {
  this.status.loading = true;
  var prm = {
    saticiTipi: this.saticiTipi,

    saticiKodu: "",
    sqlLike: val,
    limit: 0
  }

  tool.http_post(this, "SaticiList", prm).then(
    response => {
      this.items = response.body;
      this.status.loading = false;

    },
    response => {
      this.status = tool.responseToStatus(response);
    }
  );
}

function kayitupdate(val) {
  this.status.loading = true;
  val.saticiTipi = this.saticiTipi;
  tool.http_post(this, "SaticiKayit", val).then(
    response => {
      this.status.loading = false;
    },
    response => {
      this.status = tool.responseToStatus(response);
    }
  );
}

function kayitInsert(val) {
  this.status.loading = true;
  val.saticiTipi = this.saticiTipi;
  tool.http_post(this, "SaticiKayit", val).then(
    response => {
      val = response.body;
      this.items.push(val);
      this.status.loading = false;
    },
    response => {
      this.status = tool.responseToStatus(response);
    }
  );
}
///-------------------



</script>
